import { render, staticRenderFns } from "./GroupInfo.vue?vue&type=template&id=505d4046"
import script from "./GroupInfo.vue?vue&type=script&lang=js"
export * from "./GroupInfo.vue?vue&type=script&lang=js"
import style0 from "./GroupInfo.vue?vue&type=style&index=0&id=505d4046&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports